import React from 'react'

import './Sunny.css';

function Sunny() {
  return (
    
    <div className="Background">

        <div className='BackgroundArt'>
            <div className='Sun'/>
        </div>
    
    
    </div>

  )
}

export default Sunny;
